// extracted by mini-css-extract-plugin
module.exports = {"wallet_confirm":"WaitingConfirmation_wallet_confirm__230nF"};